import React from 'react';
import type { LandingCommunicationContent } from '../content/types';

export type LandingBlockTone = 'dark' | 'light' | 'accent';

export type LandingPitchBlockProps = {
  content: LandingCommunicationContent['pitch'];
  tone?: LandingBlockTone;
  className?: string;
};

const headingColor: Record<LandingBlockTone, string> = {
  dark: 'text-white',
  light: 'text-slate-950',
  accent: 'text-white',
};

const bodyColor: Record<LandingBlockTone, string> = {
  dark: 'text-white/80',
  light: 'text-slate-700',
  accent: 'text-white/90',
};

/**
 * LandingPitchBlock — emotional "why it matters" block.
 * Pure presentational. Consumes the pitch shape from the landing
 * communication content layer. Returns null when content is absent.
 */
export default function LandingPitchBlock({
  content,
  tone = 'dark',
  className = '',
}: LandingPitchBlockProps) {
  if (!content || !content.body) return null;
  return (
    <div
      data-edit-tag={content.editTag}
      className={`mx-auto max-w-3xl text-center ${className}`.trim()}
    >
      {content.headline ? (
        <h3
          className={`text-2xl font-semibold tracking-tight md:text-3xl ${headingColor[tone]}`}
        >
          {content.headline}
        </h3>
      ) : null}
      <p
        className={`${content.headline ? 'mt-4' : ''} text-lg leading-8 ${bodyColor[tone]}`}
      >
        {content.body}
      </p>
    </div>
  );
}